import { render, staticRenderFns } from "./RegistrationInformation.vue?vue&type=template&id=06d4d3ca&"
import script from "./RegistrationInformation.vue?vue&type=script&lang=js&"
export * from "./RegistrationInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports